
import { legacyConfig } from 'shared/config/legacy_config';

// Club Med has been using this font family setting from bootstrap
const SYSTEM_FONT = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";';

export const clubmedConfig = (config) => {
  legacyConfig(config);
}
